import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Typography,
  Box,
} from "@material-ui/core";
import QRCode from "qrcode.react";

import SFDialogTitle from "./SFDialogTitle";
import useSendMemberOnboardSMS from "../hooks/useSendMemberOnboardSMS";
import { useState } from "react";
import SearchBarwithButton from "./SearchBarwithButton";
import useGenerateRegisterUrl from "../hooks/useGenerateRegisterUrl";
import { Loading } from "ra-ui-materialui";
import useSFAlert from "../hooks/useSFAlert";
import { useNotify } from "react-admin";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    // height: 508,
    margin: "0 auto",
    paddingTop: 50,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  paper: {
    margin: 0,
    width: 667,
    // height: 508,
    maxWidth: 667,
    // maxHeight: 508,
  },
  dialogContent: {
    display: "flex",
    // gridTemplateRows: "100px 1fr 100px",
    margin: "0 auto",
    overflow: "hidden",
    //  flexDirection: "column",
    padding: 10,
    alignItems: "center",
  },

  dialogAction: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    margin: "0 !important",
  },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    margin: "20px 0 0 0 !important",
    borderRadius: "0px 0px",
  },
  smsContainer: {
    width: 320,
    margin: "0 !important",
  },
  helperText: {
    color: theme.red,
    alignSelf: "end",
  },
}));

const MemberRegisterQRDialog = ({ open, onClose }) => {
  const classes = useStyles();
  const [phone, setPhone] = useState();
  const { url, loading, error } = useGenerateRegisterUrl();
  const [displayError, setDisplayError] = useState();
  const { sendSMS } = useSendMemberOnboardSMS();
  const [alert] = useSFAlert();
  const notify = useNotify();
  if (loading)
    //return null;
    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        classes={{
          root: classes.allContainer,
          paper: classes.paper,
        }}
      >
        <Loading />
      </Dialog>
    );

  if (error) return null;
  const handleSendSMS = async () => {
    //return alert(phone);
    const [result, error] = await sendSMS(phone);
    if (error) return setDisplayError(error);
    return alert(JSON.stringify(result));
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      classes={{
        root: classes.allContainer,
        paper: classes.paper,
      }}
    >
      <SFDialogTitle
        id="customized-dialog-title"
        onClose={onClose}
        title="Scan QR Code"
      />
      <Typography align="center">
        Ask customer to scan QR code to fill the form
      </Typography>

      <DialogContent classes={{ root: classes.dialogContent }}>
        <QRCode
          value={url}
          style={{
            margin: "0px auto",
            width: 180,
            height: 180,
            backgroundColor: "transparent",
            alignContent: "center",
          }}
        ></QRCode>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Typography
          variant="caption"
          onClick={() => {
            navigator.clipboard.writeText(url);
            notify("Copied to clipboard");
          }}
        >
          {url}
        </Typography>
        <Typography align="center">OR</Typography>
        <Typography align="center">
          Fill customer phone to send the form
        </Typography>
        <Box className={classes.smsContainer}>
          <SearchBarwithButton
            placeholder=""
            onChange={(e) => {
              setPhone(e.target.value);
              setDisplayError(null);
            }}
            onSearch={handleSendSMS}
            noIcon
            buttonLabel="Send"
            helperText={displayError ? displayError.message : null}
            FormHelperTextProps={{
              className: classes.helperText,
            }}
          />
        </Box>

        <Button
          onClick={onClose}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
          disabled={false}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MemberRegisterQRDialog;
